class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    // this.predictiveSearchResults.style.display = 'block';
    this.predictiveSearchResults.classList.add('is-active');
  }

  close() {
    // this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.classList.remove('is-active');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');
  const navSearch = document.querySelector('.nav-search');
  const closeSearch = document.querySelector('.close-search');
  const searchBox = document.querySelector('.search-box');
  const searchInput = document.querySelector('.search__input');
  const predictiveSearch = document.querySelector('.predictive-search');
  const predictiveSearchResults = document.querySelector('.predictive-search-results');

  const closeSearchPanel = () => {
    if (searchBox) searchBox.classList.remove('is-active');
    if (predictiveSearch) predictiveSearch.classList.remove('is-active');
    body.classList.remove('no-scroll');
  };

  const openSearchPanel = () => {
    if (searchBox) searchBox.classList.add('is-active');
    if (searchInput) searchInput.focus();
    if (predictiveSearch) predictiveSearch.classList.add('is-active');
    body.classList.add('no-scroll');
  };

  if (navSearch) {
    navSearch.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = searchBox && searchBox.classList.contains('is-active');

      if (isOpen) {
        closeSearchPanel();
      } else {
        openSearchPanel();
      }
    });
  }

  if (closeSearch) {
    closeSearch.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearchPanel();
    });
  }

  if (body) {
    body.addEventListener('click', (e) => {
      const clickedInsideSearch = e.target.closest('.search-box, .predictive-search, .nav-search, .close-search');
      const isOpen = searchBox && searchBox.classList.contains('is-active');

      if (isOpen && !clickedInsideSearch) {
        closeSearchPanel();
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (predictiveSearchResults && getComputedStyle(predictiveSearchResults).display === 'flex') {
        predictiveSearchResults.style.display = 'none';
      }
      closeSearchPanel();
    }
  });
});